import React from 'react';
import './teambox.scss';
import { ReactComponent as TeamLogo } from '../../images/teamLogo.svg';
import { randomColorAndLighter } from '../../utils/functions';
import { useRef } from 'react';
import { MdDeleteForever } from 'react-icons/md';

function TeamBox({ onClick, teamName, numOfMembers, buttonText, onDelete, deletable }) {
  const { color, lighter } = randomColorAndLighter();
  const colors = useRef({ color, lighter });

  return (
    <div className="teambox" style={{ backgroundColor: colors.current.lighter }}>
      {deletable && <MdDeleteForever className="delete-icon" color="red" size={20} onClick={onDelete} />}
      <TeamLogo color={colors.current.color} className="teamLogo" />
      <h4>{teamName || 'Team Name'}</h4>
      <span>{numOfMembers || '0'}</span>
      <button onClick={() => onClick(color)}>{buttonText || 'Assign'}</button>
    </div>
  );
}

export default TeamBox;
